import {
  Checkbox as MaterialCheckbox,
  styled,
  FormControlLabel,
  FormHelperText,
  FormControl,
} from "@mui/material";
import { CheckboxProps } from "./types";
import { IndeterminateCheckBoxOutlined } from "@mui/icons-material";

const Checkbox = ({
  disabled,
  helperText,
  label,
  name,
  checked,
  className,
  onChange,
  partialChecked = false,
}: CheckboxProps) => {
  return (
    <>
      <StyledCheckboxWrapper
        className={`${name} ${className}`}
        control={
          <MaterialCheckbox
            name={name}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            indeterminate={partialChecked}
            indeterminateIcon={<IndeterminateCheckBoxOutlined />}
          />
        }
        label={label}
      />
      {helperText && (
        <span className={`MuiFormHelperText-root ${className}-helper-text`}>
          {helperText}
        </span>
      )}
    </>
  );
};

export default Checkbox;

const StyledCheckboxWrapper = styled(FormControlLabel)(() => ({
  display: "flex",
  gap: "0.5rem",
  margin: 0,
  lineHeight: "1rem",

  ">span.MuiFormControlLabel-label": {
    lineHeight: "16px",
    fontSize: "12px",
  },
  ".MuiCheckbox-root": {
    padding: 0,
    width: "1rem",
    height: "1rem",
    alignSelf: "center",
  },
}));
